module.exports = __webpack_public_path__ + "img/banner1.5c6ab7bb.png";